export default {
    label: 'Timezone',
    placeholder: 'Search timezone...',
    noOptions: 'No timezones found',
    mismatchWarning: {
        title: 'Your browser timezone doesn\'t match the selected timezone',
        detected: 'Detected',
        useDetected: 'Use detected'
    }
}

